export const SET_PROBLEMS = 'SET_PROBLEMS';
export const SET_PROBLEM = 'SET_PROBLEM';
export const SET_ACTIONS = 'SET_ACTIONS';
export const SET_ACTION = 'SET_ACTION';
export const SET_CAUSE = 'SET_CAUSE';
export const DELETE_PROBLEM = 'DELETE_PROBLEM';
export const DELETE_CAUSE = 'DELETE_CAUSE';
export const SET_PROBLEM_HISTORY = 'SET_PROBLEM_HISTORY';
export const SET_HISTORY_LOADING = 'SET_HISTORY_LOADING';
export const DELETE_ACTION = 'DELETE_ACTION';
export const SET_PROBLEM_ACCESSES = 'SET_PROBLEM_ACCESSES';
// Following mutations are created to identify the infinite problem creation loop issue
export const LOG_CLB = 'LOG_CLB';
export const INCREMENT_ADD_PROBLEM_CALLS = 'INCREMENT_ADD_PROBLEM_CALLS';
export const PB_INTERRUPTION_MODAL_DISPLAYED = 'PB_INTERRUPTION_MODAL_DISPLAYED';
export const RESUME_PROBLEM_CREATION = 'RESUME_PROBLEM_CREATION';

export default {
  SET_PROBLEMS,
  SET_PROBLEM,
  SET_ACTIONS,
  SET_ACTION,
  SET_CAUSE,
  DELETE_PROBLEM,
  DELETE_CAUSE,
  SET_PROBLEM_HISTORY,
  SET_HISTORY_LOADING,
  DELETE_ACTION,
  SET_PROBLEM_ACCESSES,
  LOG_CLB,
  INCREMENT_ADD_PROBLEM_CALLS,
  PB_INTERRUPTION_MODAL_DISPLAYED,
  RESUME_PROBLEM_CREATION,
};
